import * as React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { Panel, PanelGroup, Table, Button, PageHeader, Form, FormControl } from 'react-bootstrap';
import { Link, withRouter } from 'react-router-dom';
import { handleError } from '../../../../shared/ErrorCatching';
import * as Features from '../../../../shared/Features';
import { Translate } from '../../../../shared/LanguageService';
import ProductPropertiesIcons from '../../../propertyIcons/ProductPropertiesIcons';
import CreateGenericOrderModal from '../generic/CreateGenericOrderModal';
import * as OrderState from '../basicorderinfo/OrderState';
import * as Actions from './OrderCollectionActions';
import Typography from '@mui/material/Typography';
import { isCustomer } from '../imageprocessing/actions/ImageProcessingActions';
import { AuthenticatedUser } from '../../../../shared/types';

interface IActions {
    view: (id: number) => any;
    updateOrderCollectionName: (id: number, name: string) => any;
}

interface IProps {
    actions: IActions;
    match: any;
    orderCollection: any;
    router: any;
    user: any;
    site: any;
}

interface IState {
    showCreateGenericModal: boolean;
    editOrderCollectionName: boolean;
    currentOrderCollectionName: string;
    editedOrderCollectionName: string;
}

function shouldShowPriceToCustomer(user: AuthenticatedUser, showPrice: boolean): boolean {
    return isCustomer(user.details.role) && showPrice;
}

class ViewOrderCollectionPage extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            showCreateGenericModal: false,
            editOrderCollectionName: false,
            editedOrderCollectionName: '',
            currentOrderCollectionName: ''
        };

        this.toggleCreateGenericModal = this.toggleCreateGenericModal.bind(this);
        this.closeModalAndNavigate = this.closeModalAndNavigate.bind(this);
        this.setEditOrderCollectionNameInputState =
            this.setEditOrderCollectionNameInputState.bind(this);
        this.saveNewOrderCollectionName = this.saveNewOrderCollectionName.bind(this);
        this.onOrderCollectionNameChange = this.onOrderCollectionNameChange.bind(this);
        this.getPageHeader = this.getPageHeader.bind(this);
    }

    componentDidMount(): void {
        this.props.actions.view(this.props.match.params.orderCollectionId).catch(handleError);
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        if (nextProps.orderCollection) {
            this.setState({
                currentOrderCollectionName: nextProps.orderCollection.name
            } as IState);
        }
    }

    toggleCreateGenericModal(): void {
        this.setState({
            showCreateGenericModal: !this.state.showCreateGenericModal
        } as IState);
    }

    closeModalAndNavigate(path: string): void {
        this.setState({ showCreateGenericModal: false } as IState);
        this.props.history.push(path);
    }

    siteIs(siteName: string) {
        return this.props.site === siteName;
    }

    setEditOrderCollectionNameInputState(editOrderCollectionName: boolean) {
        this.setState({
            editOrderCollectionName: editOrderCollectionName,
            editedOrderCollectionName: this.state.currentOrderCollectionName
        } as IState);
    }

    saveNewOrderCollectionName() {
        this.props.actions
            .updateOrderCollectionName(
                this.props.match.params.orderCollectionId,
                this.state.editedOrderCollectionName
            )
            .then(() => {
                this.setState({
                    currentOrderCollectionName: this.state.editedOrderCollectionName,
                    editOrderCollectionName: false
                } as IState);
            })
            .catch((error: any) => handleError(error));
    }

    onOrderCollectionNameChange(e: any) {
        this.setState({ editedOrderCollectionName: e.target.value } as IState);
    }

    getPageHeader() {
        if (this.state.editOrderCollectionName) {
            return (
                <Form inline>
                    <span>
                        {this.props.orderCollection.orderCollectionNumber}
                        {' - '}
                    </span>
                    <FormControl
                        onChange={this.onOrderCollectionNameChange}
                        type="text"
                        value={
                            this.state.editedOrderCollectionName
                                ? this.state.editedOrderCollectionName
                                : ''
                        }
                    />{' '}
                    <Button bsStyle="primary" onClick={this.saveNewOrderCollectionName}>
                        {Translate('view-order-collection/title/button-label/save')}
                    </Button>{' '}
                    <Button
                        bsStyle="danger"
                        onClick={() => this.setEditOrderCollectionNameInputState(false)}
                    >
                        {Translate('view-order-collection/title/button-label/cancel')}
                    </Button>
                    {this.siteIs('se360') &&
                        Features.hasFeature(Features.CreateGenericOrder, this.props.user) && (
                            <Button
                                bsStyle="primary"
                                className="pull-right"
                                onClick={(e) => this.toggleCreateGenericModal()}
                            >
                                {Translate('view-order-collection/create-new-generic-order/button')}
                            </Button>
                        )}
                </Form>
            );
        } else {
            return (
                <span>
                    {this.props.orderCollection.orderCollectionNumber} -{' '}
                    {this.state.currentOrderCollectionName}
                    {Features.hasFeature(Features.UpdateOrderCollectionName, this.props.user) && (
                        <Button
                            onClick={() => this.setEditOrderCollectionNameInputState(true)}
                            bsSize="xsmall"
                        >
                            <i className="material-icons">mode_edit</i>
                        </Button>
                    )}
                    {this.siteIs('se360') &&
                        Features.hasFeature(Features.CreateGenericOrder, this.props.user) && (
                            <Button
                                bsStyle="primary"
                                className="pull-right"
                                onClick={(e) => this.toggleCreateGenericModal()}
                            >
                                {Translate('view-order-collection/create-new-generic-order/button')}
                            </Button>
                        )}
                </span>
            );
        }
    }

    displayLegacyOrderNumber(order) {
        if (
            order.legacyOrderNumber !== null &&
            this.props.orderCollection.orderCollectionNumber !== order.legacyOrderNumber
        ) {
            return <span> ({order.legacyOrderNumber})</span>;
        }
    }

    getLinkURL(order) {
        let urlTail = 'basic';

        if (order.orderTypes[0].translateKey === 'order-type/plan') {
            urlTail = `basic`;
        } else if (order.orderTypes[0].translateKey === `order-type/photo`) {
            urlTail = `basic`;
        } else if (order.orderTypes[0].translateKey === `order-type/generic`) {
            urlTail = `basic`;
        } else if (order.orderTypes[0].translateKey === `order-type/showcase`) {
            urlTail = `basic`;
        }

        return `/orders/${order.orderId}/${urlTail}`;
    }

    render() {
        return (
            <div className="order-collection-page">
                <PageHeader xs={12}>{this.getPageHeader()}</PageHeader>
                <PanelGroup id="order-collection-group">
                    {this.props.orderCollection.orders.map((order) => (
                        <Panel
                            className={
                                order.orderTypes.map((x) => x.displayName).join('-') + '-order'
                            }
                            key={order.orderId}
                        >
                            <Panel.Heading>
                                <Panel.Title>
                                    <Link to={this.getLinkURL(order)}>
                                        {Translate(
                                            'view-order-collection/order-panel/header/partial-order-number'
                                        )}{' '}
                                        {this.props.orderCollection.orderCollectionNumber}:
                                        {order.orderNumber}
                                        {this.displayLegacyOrderNumber(order)}
                                        <ProductPropertiesIcons
                                            properties={order.productProperties}
                                        />
                                    </Link>
                                    {order.orderState.value === OrderState.Removed && (
                                        <span
                                            className="label label-danger"
                                            style={{ marginLeft: '1em' }}
                                        >
                                            {Translate(order.orderState.displayName)}
                                        </span>
                                    )}
                                    <span className="pull-right">
                                        {moment(order.createdAt).calendar()}
                                    </span>
                                </Panel.Title>
                            </Panel.Heading>
                            <Panel.Body>
                                <dl>
                                    <dt>
                                        {Translate(
                                            'view-order-collection/order-panel/content/partial-broker-firm-label'
                                        )}
                                    </dt>
                                    <dd>{order.brokerFirm}</dd>
                                    <dt>
                                        <div>
                                            {Translate(
                                                'view-order-collection/order-panel/content/partial-order-type-label'
                                            )}
                                        </div>
                                    </dt>
                                    <dd>
                                        {order.orderTypes
                                            .map((x) => Translate(x.translateKey))
                                            .join(', ')}
                                    </dd>
                                </dl>
                                <Table condensed responsive>
                                    <thead>
                                        <tr className="table_header">
                                            <th>
                                                {Translate(
                                                    'view-order-collection/order-rows/table-headers/name'
                                                )}{' '}
                                            </th>
                                            <th className="text-center">
                                                {Translate(
                                                    'view-order-collection/order-rows/table-headers/quantity'
                                                )}
                                            </th>
                                            {(Features.hasFeature(
                                                Features.ViewProductPriceBrokerFirm,
                                                this.props.user
                                            ) ||
                                                shouldShowPriceToCustomer(
                                                    this.props.user,
                                                    order.showPrice
                                                )) && (
                                                <th className="text-center">
                                                    {shouldShowPriceToCustomer(
                                                        this.props.user,
                                                        order.showPrice
                                                    )
                                                        ? Translate(
                                                              'agreements/modal/list/table-header/price'
                                                          )
                                                        : Translate(
                                                              'view-order-collection/order-rows/table-headers/customer-price'
                                                          )}
                                                </th>
                                            )}
                                            {Features.hasFeature(
                                                Features.ViewPhotographerCompensationInOrderCollection,
                                                this.props.user
                                            ) && (
                                                <th className="text-center">
                                                    {Translate(
                                                        'view-order-collection/order-rows/table-headers/compensation'
                                                    )}
                                                </th>
                                            )}
                                            {Features.hasFeature(
                                                Features.ProductPricePropertyOwner,
                                                this.props.user
                                            ) && (
                                                <th className="text-center">
                                                    {Translate(
                                                        'view-order-collection/order-rows/table-headers/owner-price'
                                                    )}
                                                </th>
                                            )}
                                            <th className="text-center">
                                                {Translate(
                                                    'view-order/basic-order-info/products/table-headers/invoice-status'
                                                )}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {order.orderRows.map((orderRow) => (
                                            <tr key={orderRow.id}>
                                                <td>{orderRow.productName}</td>
                                                <td className="text-center">{orderRow.quantity}</td>
                                                {(Features.hasFeature(
                                                    Features.ViewProductPriceBrokerFirm,
                                                    this.props.user
                                                ) ||
                                                    order.showPrice) && (
                                                    <td className="text-center">
                                                        {orderRow.productPriceBrokerFirm}
                                                    </td>
                                                )}
                                                {Features.hasFeature(
                                                    Features.ViewPhotographerCompensationInOrderCollection,
                                                    this.props.user
                                                ) && (
                                                    <td className="text-center">
                                                        {orderRow.productPhotographerCompensation}
                                                    </td>
                                                )}
                                                {Features.hasFeature(
                                                    Features.ProductPricePropertyOwner,
                                                    this.props.user
                                                ) && (
                                                    <td className="text-center">
                                                        {orderRow.productPricePropertyOwner}
                                                    </td>
                                                )}
                                                <td className="text-center">
                                                    {Translate(orderRow.invoiceStatus.displayName)}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                                {shouldShowPriceToCustomer(this.props.user, order.showPrice) ? (
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'flex-end',
                                            fontWeight: '700'
                                        }}
                                    >
                                        {Translate('orders/create/panel-headings/total-cost')}:{' '}
                                        {order.orderRows.reduce(
                                            (acc, elem) => acc + elem.productPriceBrokerFirm,
                                            0
                                        )}
                                    </Typography>
                                ) : null}
                            </Panel.Body>
                        </Panel>
                    ))}
                    {this.props.orderCollection &&
                    this.props.orderCollection.orders.length > 0 &&
                    shouldShowPriceToCustomer(
                        this.props.user,
                        this.props.orderCollection.orders[0].showPrice
                    ) ? (
                        <Typography
                            variant="body1"
                            sx={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                fontSize: '20px',
                                fontWeight: '700',
                                padding: '20px 0'
                            }}
                        >
                            {Translate('orders/create/panel-headings/total-cost')}:{' '}
                            {this.props.orderCollection.orders.reduce((overallSum, order) => {
                                return (
                                    overallSum +
                                    order.orderRows.reduce((sum, orderRow) => {
                                        return sum + orderRow.productPriceBrokerFirm;
                                    }, 0)
                                );
                            }, 0)}
                        </Typography>
                    ) : null}
                </PanelGroup>
                {this.state.showCreateGenericModal && (
                    <CreateGenericOrderModal
                        orderCollectionId={this.props.orderCollection.id}
                        showModal={this.state.showCreateGenericModal}
                        closeModal={this.toggleCreateGenericModal}
                        closeAndNavigate={this.closeModalAndNavigate}
                    />
                )}
            </div>
        );
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        orderCollection: state.orderCollection.model,
        user: state.user,
        site: state.site
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            view: (id: number) => dispatch(Actions.view(id)),
            updateOrderCollectionName: (id: number, name: string) =>
                dispatch(Actions.updateOrderCollectionName(id, name))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ViewOrderCollectionPage));
